import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 盘点状态
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    CONFIRMING = new Meta(3, "确认中");
    TO_BE_INITIATE = new Meta(7, "待发起");
    TO_BE_SIGNED = new Meta(8, "待签署");
    WAIT_CONFIRM = new Meta(2, "待确认");
    SIGNING = new Meta(4, "签署中");
    REJECTED = new Meta(6, "已驳回");
    FINISHED = new Meta(5, "盘点完成");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
    TO_BE_INVENTORIED = new Meta(11, "待盘点");
}
// 草稿、确认中、待发起、待签署、签署中、已驳回、盘点完成、作废中、已作废
export const STATE = new State();

/**
 * 签署方式
 */
class SignType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const SIGN_TYPE = new SignType();

/**
 * 盘点类型
 */
class Type extends UltMeta {
    DAILY = new Meta(1, "每日盘点");
    REGULAR = new Meta(2, "定期盘点");
    TEMPORARY = new Meta(3, "临时盘点");
}

export const TYPE = new Type();

/**
 * 保存类型
 */
class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}

export const SAVE_TYPE = new SaveType();
